import { useCallback } from 'react';

import { useOnCurrentTimeChanged } from '@/scenarios/legacy-player/hooks/useOnCurrentTimeChanged';

import { usePrerollDuration } from './use-preroll-duration';

const PREROLL_STAGE_CHECK_DELAY = 250;

interface Props {
    onStart: () => void;
    onClose: () => void;
}

export const usePrerollStageWatcher = ({ onStart, onClose }: Props) => {
    const prerollDuration = usePrerollDuration();

    const onCurrentTimeChanged = useCallback(
        (currentTime: number) => {
            if (!prerollDuration) {
                return;
            }
            if (currentTime < prerollDuration) {
                onStart();
            } else {
                onClose();
            }
        },
        [onClose, onStart, prerollDuration]
    );

    useOnCurrentTimeChanged(onCurrentTimeChanged, PREROLL_STAGE_CHECK_DELAY);
};
